import React from 'react';
import { Modal, Message, Grid } from 'semantic-ui-react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import QueryStringModal from 'components/QueryStringModal';

// Global types
import { AppState } from 'services/types';

// Global selectors
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

import { updateQueryString } from 'services/router/actions';

import {
    makeSelectQueryStringErrorMessage,
    makeSelectQueryStringErrorHeaderValue
} from './selectors';

import { ERROR_MODAL_QUERY_STRING_PARAM } from './constants';

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
}

interface ConnectedProps {
    namespace?: string;
    errorMessage?: string;
    requestId?: string;
}

type Props = ConnectedProps & DispatchProps;

export class ErrorModalComponent extends React.PureComponent<Props> {
    componentDidUpdate(): void {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { namespace, errorMessage, updateQueryString } = this.props;

        if (namespace && !errorMessage) {
            updateQueryString({
                [ERROR_MODAL_QUERY_STRING_PARAM]: undefined
            });
        }
    }

    render(): React.ReactElement {
        const { errorMessage, requestId } = this.props;

        return (
            <QueryStringModal
                param={ERROR_MODAL_QUERY_STRING_PARAM}
                modalProps={{
                    size: 'tiny'
                }}
            >
                <React.Fragment>
                    <Modal.Header>Ooops!</Modal.Header>
                    <Modal.Content>
                        <Message error>
                            <Grid>
                                <Grid.Row>{errorMessage}</Grid.Row>
                                {requestId && (
                                    <Grid.Row>Reference: {requestId}</Grid.Row>
                                )}
                            </Grid>
                        </Message>
                    </Modal.Content>
                </React.Fragment>
            </QueryStringModal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    namespace: makeSelectQueryStringValue(ERROR_MODAL_QUERY_STRING_PARAM),
    errorMessage: makeSelectQueryStringErrorMessage(
        ERROR_MODAL_QUERY_STRING_PARAM
    ),
    requestId: makeSelectQueryStringErrorHeaderValue(
        ERROR_MODAL_QUERY_STRING_PARAM,
        'x-request-id'
    )
});

export default connect(mapStateToProps, { updateQueryString })(
    ErrorModalComponent
);
